import { render, staticRenderFns } from "./CompanyInfoCard.vue?vue&type=template&id=ec12fc78&"
import script from "./CompanyInfoCard.vue?vue&type=script&lang=js&"
export * from "./CompanyInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInfoCard.vue?vue&type=style&index=0&id=ec12fc78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports